import { Components, Theme as MuiTheme } from '@mui/material';
import { designTokens } from '../themes/design-tokens';

export const autocompleteTheme: Components<MuiTheme> = {
  MuiAutocomplete: {
    styleOverrides: {
      root: ({ theme }) => ({
        '& .MuiOutlinedInput-root': {
          borderRadius: `${designTokens.textField.borderRadius}px`,
          '& .MuiAutocomplete-endAdornment': {
            right: 16,
          },
        },

        // Custom rounded variant
        '&.Autocomplete-rounded': {
          '& .MuiOutlinedInput-root': {
            height: theme.spacing(12), // 48px
            borderRadius: '90px',
            paddingLeft: '16px',
            paddingRight: '40px',

            '& fieldset': {
              borderWidth: '2px',
              borderColor: theme.palette.text.second,
              borderRadius: '90px',
              transition: theme.transitions.create(
                ['border-color', 'box-shadow'],
                {
                  duration: theme.transitions.duration.shorter,
                  easing: theme.transitions.easing.easeInOut,
                },
              ),
            },
            '&:hover:not(.Mui-disabled) fieldset': {
              borderColor: theme.palette.primary.light,
              boxShadow: `0 0 10px 1px ${theme.palette.primary.light}`,
            },
            '&.Mui-focused fieldset': {
              borderWidth: '2px',
              borderColor: theme.palette.primary.main,
              boxShadow: `0 0 10px 0 ${theme.palette.primary.main}`,
            },
            '&.Mui-error fieldset': {
              borderWidth: '2px',
              borderColor: theme.palette.error.main,
              boxShadow: `0 0 10px 0 ${theme.palette.error.main}`,
            },
            '&.Mui-disabled fieldset': {
              borderColor: theme.palette.text.fourth,
            },
          },
        },
      }),
      tag: ({ theme }) => ({
        margin: theme.spacing(0.75),
        marginLeft: 0,
      }),
      option: ({ theme }) => ({
        marginInline: designTokens.spacing.sm,
        borderRadius: designTokens.borderRadius.md,
        paddingInline: designTokens.spacing.md,
        paddingBlock: designTokens.spacing.xs,
        '&:hover, &[aria-selected="true"]': {
          // backgroundColor: designTokens.colors.purple[50],
          color: designTokens.colors.neutral[900],
        },
        '&:not(:last-child)': {
          marginBottom: theme.spacing(0.5),
        },
      }),
    },
  },
};
